export const PHONE = /^\+?\d{1}\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/;
export const PHONE_VAIDATOR = /^.*\d\s\((\d){3}\)\s(\d){3}-(\d){2}-(\d){2}$/;
